//TODO: Finish building
import React from 'react';
import Layout from '../../../layout/Layout';

import CoursesComingSoon from '../../../components/academy/indexPage/CoursesComingSoon';
import AcademyLeftNavBar from '../../../components/academy/sidebarNav/AcademyLeftNavBar';

import { ArticleQuery } from '../../../types/api/AcademyTypes';

const CoursesPage: React.FC<{}> = ({}) => {
  const [selectedFilters, setSelectedFilters] = React.useState<ArticleQuery>({});

  const headContent = {
    title: "Academy Courses",
  };

  return (
    <Layout head={headContent}>
      <div className="flex flex-col md:flex-row w-full bg-[#252A2D]">
        <AcademyLeftNavBar
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
          filtersDisabled={false}
        />
        <CoursesComingSoon />
      </div>
    </Layout>
  );
};

export default CoursesPage;
